import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CandidatesJobsAlert } from '../../models/candidatesJobsAlert.model';
import { Trainings } from '../../models/trainings.model';
import { Professions } from '../../models/professions.model';
import { UsersService } from '../../services/users.service'
import { FunctionsService } from '../../services/functions.service';
import { HttpService } from '../../services/http.service';
import { Candidates } from '../../models/candidates.model';
import Swal from 'sweetalert2';
import { Jobs } from '../../models/jobs.model';
import { Router } from '@angular/router';
import { CandidatesEducationsAlert } from '../../models/candidatesEducationsAlert.model';

@Component({
  selector: 'app-my-backup',
  templateUrl: './my-backup.component.html',
  styleUrls: ['./my-backup.component.scss']
})
export class MyBackupComponent implements OnInit {
  candidates: Candidates = new Candidates([]);
  jobAlertIsLoading: boolean = false;
  jobAlertForm: FormGroup = new FormGroup({});
  CandidatesJobsAlertList: CandidatesJobsAlert[] = [];
  trainingList: Trainings[] = [];
  professionList: Professions[] = [];
  jobList: Jobs[] = [];
  
  educationCategoriesList: any[] = [];
  educationAlertIsLoading: boolean = false;
  educationAlertForm: FormGroup = new FormGroup({});
  candidatesEducationsAlertList: CandidatesEducationsAlert[] = [];

  constructor(private router: Router, private formBuilder: FormBuilder, private usersService: UsersService, public functionsService: FunctionsService, private httpService: HttpService) {
    if (usersService.getUserType() == 'entreprise') {
      this.router.navigate(['/accueil/entreprise']);
    }
    this.candidates = this.usersService.getCurrentUser();
  }

  ngOnInit() {
    this.initEducationform();
    this.initJobAlertForm();
    const jobList = this.candidates.getCandidatesSaveJobs();
    
    jobList.forEach(element => {
      const jobs = new Jobs(element);
      this.jobList.push(jobs);
    });
  }
  
  initEducationform() {
    this.getEducationsCategories();
    this.getCandidatesEducationsAlertList();
    this.trainingList = this.functionsService.getTrainingsList();
    this.professionList = this.functionsService.getProfessionsList();
    this.educationAlertForm = this.formBuilder.group({
      category: ['', Validators.required]
    });
  }
  
  onSubmitEducationAlertForm() {
    let formValue: any = this.educationAlertForm.value;

    this.educationAlertIsLoading = true;

    this.httpService.addCandidateEducationAlert(formValue, this.candidates.getToken()).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          localStorage.setItem('currentCandidate', JSON.stringify(data));
          this.educationAlertIsLoading = false;
          Swal.fire({
            icon: 'success',
            title: 'Excellent !',
            text: 'Alerte emploi ajoutée.',
          })
          this.initEducationform();
          this.candidates = this.usersService.getCurrentUser();
          this.getCandidatesEducationsAlertList();
        }
      },
      (error) => {
        this.educationAlertIsLoading = false;
        if (error.error.message == 'CANDIDATE_EDUCATIONS_ALERT_ALREADY_EXIST') {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Cette alerte existe déjà.',
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          })
        }
      }
    );
  }

  removeEducationAlert(id: number) {
    Swal.fire({
      title: 'Souhaiter supprimer cette alerte ?',
      showDenyButton: true,
      confirmButtonText: 'Oui',
      denyButtonText: `Non`,
      confirmButtonColor: '#28a745',
      denyButtonColor: 'dc3545'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Veuillez patientez...');
        this.httpService.removeCandidateEducationAlert(id, this.candidates.getToken()).subscribe(
          (response: any) => {
            if (response.status == "success") {
              let data = response.data;
              localStorage.setItem('currentCandidate', JSON.stringify(data));
              Swal.fire({
                icon: 'success',
                title: 'Excellent !',
                text: 'Alerte supprimée.',
              });
              this.initEducationform();
              this.candidates = this.usersService.getCurrentUser();
              this.getCandidatesEducationsAlertList();
            }
          },
          (error) => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        );
      }
    })
  }

  initJobAlertForm() {
    this.getCandidatesJobsAlertList();
    this.trainingList = this.functionsService.getTrainingsList();
    this.professionList = this.functionsService.getProfessionsList();
    this.jobAlertForm = this.formBuilder.group({
      level_of_study: ['', Validators.required],
      training_id: ['', Validators.required],
      years_of_experience: ['', Validators.required],
      profession_id: ['', Validators.required],
    });
  }

  removeBackupJob(jobID: number) {
    Swal.fire({
      title: 'Souhaiter vous supprimer cette offre ?',
      showDenyButton: true,
      confirmButtonText: 'Oui',
      denyButtonText: `Non`,
      confirmButtonColor: '#28a745',
      denyButtonColor: 'dc3545'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Veuillez patientez...');
        this.httpService.removeBackupJob(jobID, this.candidates.getToken()).subscribe(
          (response: any) => {
            if (response.status == "success") {
              let data = response.data;
              localStorage.setItem('currentCandidate', JSON.stringify(data));
              Swal.fire({
                icon: 'success',
                title: 'Excellent !',
                text: 'Offre d\'emploi supprimée.',
              });
              this.candidates = this.usersService.getCurrentUser();
              const jobList = this.candidates.getCandidatesSaveJobs();
              this.jobList = [];
              jobList.forEach(element => {
                const jobs = new Jobs(element);
                this.jobList.push(jobs);
              });
            }
          },
          (error) => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        );
      }
    })
  }

  onSubmitJobAlertForm(): any {
    let formValue: any = this.jobAlertForm.value;

    this.jobAlertIsLoading = true;

    this.httpService.addCandidateJobAlert(formValue, this.candidates.getToken()).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          localStorage.setItem('currentCandidate', JSON.stringify(data));
          this.jobAlertIsLoading = false;
          Swal.fire({
            icon: 'success',
            title: 'Excellent !',
            text: 'Alerte emploi ajoutée.',
          })
          this.initJobAlertForm();
          this.candidates = this.usersService.getCurrentUser();
          this.getCandidatesJobsAlertList();
        }
      },
      (error) => {
        this.jobAlertIsLoading = false;
        if (error.error.message == 'CANDIDATE_JOB_ALERT_ALREADY_EXIST') {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Cette alerte existe déjà.',
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          })
        }
      }
    );
  }

  removeJobAlert(id: number) {
    Swal.fire({
      title: 'Souhaiter supprimer cette alerte ?',
      showDenyButton: true,
      confirmButtonText: 'Oui',
      denyButtonText: `Non`,
      confirmButtonColor: '#28a745',
      denyButtonColor: 'dc3545'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Veuillez patientez...');
        this.httpService.removeCandidateJobAlert(id, this.candidates.getToken()).subscribe(
          (response: any) => {
            if (response.status == "success") {
              let data = response.data;
              localStorage.setItem('currentCandidate', JSON.stringify(data));
              Swal.fire({
                icon: 'success',
                title: 'Excellent !',
                text: 'Alerte supprimée.',
              });
              this.initJobAlertForm();
              this.candidates = this.usersService.getCurrentUser();
              this.getCandidatesJobsAlertList();
            }
          },
          (error) => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        );
      }
    })
  }

  getCandidatesEducationsAlertList() {
    const candidatesEducationsAlert: any = this.candidates.getCandidatesEducationsAlerts();

    this.candidatesEducationsAlertList = [];

    candidatesEducationsAlert.forEach((element: any) => {
      let candidatesEducationsAlert = new CandidatesEducationsAlert(element);
      this.candidatesEducationsAlertList.push(candidatesEducationsAlert);
    });
  }

  getCandidatesJobsAlertList() {
    const candidatesJobsAlert: any = this.candidates.getCandidatesJobsAlerts();

    this.CandidatesJobsAlertList = [];

    candidatesJobsAlert.forEach((element: any) => {
      let candidatesJobsAlert = new CandidatesJobsAlert(element);
      this.CandidatesJobsAlertList.push(candidatesJobsAlert);
    });
  }

  getEducationsCategories() {
    this.httpService.getEducationsCategories().subscribe(
      (response: any) => {
        if (response.status == "success") {
          this.educationCategoriesList = response.data.list;
        }
      },
      (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        })
      }
    );
  }
}
